import React from 'react'
import { Accordion, type AccordionProps } from '@mui/material'

interface EnhancedAccordionProps extends Omit<AccordionProps, 'onChange'> {
  expanded: boolean
  onExpandedChange: (isExpanded: boolean) => void
}

export const EnhancedAccordion: React.FC<EnhancedAccordionProps> = ({
  expanded,
  onExpandedChange,
  children,
  ...props
}) => {
  const handleAccordionChange = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLElement
    const isSelectElement =
      target.closest('.MuiSwitch-root') != null ||
      target.closest('.MuiSelect-root') != null ||
      target.closest('.MuiMenuItem-root') != null ||
      target.closest('.MuiAutocomplete-root') != null ||
      target.closest('.MuiDatePicker-root') != null ||
      target.closest('.MuiPickersPopper-root') != null ||
      target.closest('.MuiPickersDay-root') != null ||
      target.closest('.MuiPickersCalendarHeader-root') != null ||
      target.closest('.MuiTextField-root') != null

    if (!isSelectElement) {
      onExpandedChange(!expanded)
    }
  }

  return (
    <Accordion {...props} expanded={expanded} onChange={handleAccordionChange}>
      {children}
    </Accordion>
  )
}
